import { render } from "./readyToUsePackageModel.vue?vue&type=template&id=993dd610"
import script from "./readyToUsePackageModel.vue?vue&type=script&lang=js"
export * from "./readyToUsePackageModel.vue?vue&type=script&lang=js"

import "./readyToUsePackageModel.vue?vue&type=style&index=0&id=993dd610&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__